let isRc = location.href.match(/(rc\.|rc\-|rc2\-)/i) ? location.href.match(/(rc\.|rc\-|rc2\-)/i)[1] : '';
isRc = (isRc == 'rc2-') ? 'rc-' : isRc;
if(location.href.match(/(op\-|opdev\-)/i)) isRc = 'opdev-';

let isNcv = /ncvgames/i.test(location.href);

// 현재 도메인 설정
let nowDomain = '';
if(/(asia\.nc\.com)/i.test(location.href)) {
  nowDomain = 'asia.nc.com';  
} else if(isNcv) {
  nowDomain = 'noti.ncvgames.com';
} else {
  nowDomain = 'noti.plaync.com';
}

// 헤더설정
export let customHeader = {
  'Content-Type': 'application/json',
  'X-Nc-Publisher': isNcv ? 'NCV' : 'NCK'
};

let api = {
  count: location.protocol + '//' + isRc + nowDomain + '/api/common/count.json', //알림카운트
  list: location.protocol + '//' + isRc + nowDomain + '/api/common/list.json', //노티리스트
  confirm: location.protocol + '//' + isRc + nowDomain + '/api/common/confirm.json', //노티읽음 확인

  // 알림 설정
  settingList: `${location.protocol}//${isRc}${nowDomain}/api/common/getReceiveSetting.json`,
  settingReject: `${location.protocol}//${isRc}${nowDomain}/api/common/updateReceiveSetting.json`,

  // 친구신청에서 사용하는 알림삭제
  deleteNoti: `${location.protocol}//${isRc}${nowDomain}/api/common/delete.json`, //알림삭제

  // 친구신청 -> jsonp 호출
  accept: `https://${isRc}sandbox.plaync.com/$!/my/friend/propose/accept.jsonp`, //친구수락
  friendAgree: `https://${isRc}sandbox.plaync.com/$!/my/profile/updateAgreeFriendAccept.jsonp`, //약관동의
  hideNoti: (puid, prid) => { //친구신청숨기기
    const prefix = `https://${isRc}sandbox.plaync.com`;
    return `${prefix}/$!/bns/friend/${puid}/${prid}/propose/hide.jsonp`;
  }

};

if (/local\.|localhost|ui-static\.|file:/i.test(location.href)) {
  api = {
    count: 'http://ui-static.korea.ncsoft.corp/uikit/cnb/data/noticountdummydata.json',
    list: 'http://ui-static.korea.ncsoft.corp/uikit/cnb/data/notilistdummydata.json',
    confirm: '',

    // 알림 설정
    settingList: 'http://ui-static.korea.ncsoft.corp/uikit/cnb/data/notisettingdummydata.json',
    settingReject: 'http://ui-static.korea.ncsoft.corp/uikit/cnb/data/notisettingdummydata2.json',

    // 친구신청에서 사용하는 알림삭제
    deleteNoti: 'http://ui-static.korea.ncsoft.corp/uikit/cnb/data/notideletedummydata.json',
  };
}

export default api;


